import React, { useEffect, useState } from "react";
import { ReactComponent as BackArrow } from "../../Icons/BorderBackArrow.svg";
import {
  Box,
  Grid,
  Typography,
  Stack,
  Button,
  IconButton,
  Divider,
  CircularProgress,
} from "@mui/material";
import {
  PrimaryTypography,
  SecondaryTypography,
  StyledSecondaryTypography,
  TypographyDefault,
  StyledSecondaryServiceTypography,
} from "../../Theme";
import { ReactComponent as EditIcon } from "../../Icons/Edit.svg";
import { ReactComponent as PDFIcon } from "../../Icons/Pdf.svg";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../AxiosInstance";
import moment from "moment";
import { ReactComponent as ExclamatoryIcon } from "../../Icons/Exclamatory.svg";

const ReviewAccount = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [PDF, setPDF] = useState({
    fileName: "",
    fileSize: "",
    fileType: "",
    path: "",
  });
  const [accountDetails, setAccountDetails] = useState(null);
  const tabs = ["Detail", "Contract"];
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState("Detail");
  const reviewstyle = {
    minHeight: "61px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "10px 0",
  };

  const getAccountDetails = () => {
    setLoading(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}property/${id}`)
      .then((res) => {
        console.log(res.data?.data?.property);
        setAccountDetails(res.data?.data?.property);
        setPDF({
          fileName:
            res.data?.data?.property?.billing_detail?.contract_doc?.name,
          fileSize:
            res.data?.data?.property?.billing_detail?.contract_doc?.file_size,
          fileType:
            res.data?.data?.property?.billing_detail?.contract_doc?.file_type,
          path: res.data?.data?.property?.billing_detail?.contract_doc?.path,
        });
        setLoading(false);
      })

      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  useEffect(() => {
    getAccountDetails();
  }, []);
  const formatDate = (isoDateString) => {
    return moment(isoDateString).format("DD-MM-YYYY");
  };
  const handleOpenPdf = () => {
    const filePath = `${process.env.REACT_APP_FILE_PATH}/${PDF.path}`;
    const newTab = window.open(filePath, "_blank");
    newTab?.focus();
  };
  console.log("Pdf", PDF);
  return loading ? (
    <Box
      sx={{ width: "100%", height: "90vh" }}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <CircularProgress />
    </Box>
  ) : (
    <>
      <Box>
        <BackArrow
          onClick={() => navigate("/sales-overview")}
          style={{ marginBottom: "20px", cursor: "pointer" }}
        />
        <PrimaryTypography>{accountDetails?.title}</PrimaryTypography>
        <StyledSecondaryServiceTypography>
          Last Updated: {formatDate(accountDetails?.updated_at)}
        </StyledSecondaryServiceTypography>
      </Box>
      <Stack
        mt={3}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        px="16px"
        sx={{
          height: "66px",
          backgroundColor: "#FCFCFD",
          border: "1px solid #E5E7EB",
          borderRadius: "8px 8px 0px 0px",
        }}
      >
        <Box
          sx={{
            border: "1px solid #D2D6DB",
            display: "flex",
            borderRadius: "10px",
            overflowX: "scroll",
            "::-webkit-scrollbar": { display: "none" },
          }}
        >
          {tabs.map((value, index) => (
            <Box
              key={index}
              onClick={() => {
                setSelectedTab(value);
              }}
              sx={{
                borderRadius:
                  index === 1
                    ? "0px 8px 8px 0px"
                    : index === 0
                    ? "8px 0px 0px 8px"
                    : "initial",
                borderLeft: index !== 0 ? "1px solid #E5E7EB" : "initial",
                backgroundColor: value == selectedTab ? "#F3F4F6" : "initial",
                width: `${value.length * 12}px`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "&:hover": { cursor: "pointer" },
              }}
            >
              <Typography
                sx={{
                  color: value === selectedTab ? "#111927" : "#4D5761",
                  fontSize: "14px",
                  fontWeight: 600,
                }}
                textAlign={"center"}
              >
                {value}
              </Typography>
            </Box>
          ))}
        </Box>
        <Button
          onClick={() => navigate(`/edit-account/${id}`)}
          type="button"
          sx={{ width: "fit-content" }}
          variant="Standard"
        >
          <IconButton sx={{ paddingLeft: "10px" }}>
            {" "}
            <EditIcon width="14px" />
          </IconButton>
          Edit{" "}
        </Button>
      </Stack>
      {selectedTab === "Detail" ? (
        <>
          <Box
            component="div"
            boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
            // borderRadius="8px 8px 0px 0px"
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              px="16px"
              sx={{
                height: "66px",
                backgroundColor: "#FCFCFD",
                border: "1px solid #E5E7EB",
              }}
            >
              <Stack direction="row" alignItems="center" gap="10px">
                <SecondaryTypography>Company Details</SecondaryTypography>
              </Stack>
            </Stack>
            <Grid
              container
              xs={12}
              gap="2.8%"
              sx={{
                backgroundColor: "white",
                padding: "30px 16px 30px 16px",
                border: "1px solid #E5E7EB",
              }}
            >
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Company Name
                </StyledSecondaryTypography>
                <TypographyDefault>
                  {accountDetails?.company?.name}
                </TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>Country</StyledSecondaryTypography>
                <TypographyDefault>
                  {accountDetails?.company?.country}
                </TypographyDefault>
              </Grid>
              <Divider
                sx={{
                  borderTop: "1px solid #F3F4F6",
                  width: "100%",
                  marginTop: "10px",
                }}
              />
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Company Email Address
                </StyledSecondaryTypography>
                <TypographyDefault>
                  {accountDetails?.company?.email}
                </TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Contact Number
                </StyledSecondaryTypography>
                <TypographyDefault>
                  +{accountDetails?.company?.country_code}{" "}
                  {accountDetails?.company?.phone}
                </TypographyDefault>
              </Grid>
              <Divider
                sx={{
                  borderTop: "1px solid #F3F4F6",
                  width: "100%",
                  marginTop: "10px",
                }}
              />
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Company Address
                </StyledSecondaryTypography>
                <TypographyDefault>
                  {accountDetails?.company?.address}
                </TypographyDefault>
              </Grid>
            </Grid>
          </Box>

          <Box
            // mt={3}
            component="div"
            boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
            // borderRadius="8px"
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              px="16px"
              sx={{
                height: "66px",
                backgroundColor: "#FCFCFD",
                border: "1px solid #E5E7EB",
                // borderRadius: "8px 8px 0 0 ",
              }}
            >
              <Stack direction="row" alignItems="center" gap="10px">
                <SecondaryTypography>Billing Details</SecondaryTypography>
              </Stack>
            </Stack>
            <Grid
              container
              xs={12}
              gap="2.8%"
              sx={{
                backgroundColor: "white",
                padding: "30px 16px 30px 16px",
                border: "1px solid #E5E7EB",
              }}
            >
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Contract Terms
                </StyledSecondaryTypography>
                <TypographyDefault>
                  {accountDetails?.billing_detail?.contract_terms_year} Years{" "}
                  {accountDetails?.billing_detail?.contract_terms_month} Months
                </TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Billing Entity
                </StyledSecondaryTypography>
                <TypographyDefault>
                  {accountDetails?.billing_detail?.entity}
                </TypographyDefault>
              </Grid>
              <Divider
                sx={{
                  borderTop: "1px solid #F3F4F6",
                  width: "100%",
                  marginTop: "10px",
                }}
              />
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Commence Date
                </StyledSecondaryTypography>
                <TypographyDefault>
                  {" "}
                  {accountDetails?.billing_detail?.commence_date}{" "}
                </TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>End Date</StyledSecondaryTypography>
                <TypographyDefault>
                  {" "}
                  {accountDetails?.billing_detail?.end_date}{" "}
                </TypographyDefault>
              </Grid>
              <Divider
                sx={{
                  borderTop: "1px solid #F3F4F6",
                  width: "100%",
                  marginTop: "10px",
                }}
              />
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>Full Name</StyledSecondaryTypography>
                <TypographyDefault>
                  {" "}
                  {accountDetails?.billing_detail?.name}
                </TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Billing Email Address
                </StyledSecondaryTypography>
                <TypographyDefault>
                  {accountDetails?.billing_detail?.email}
                </TypographyDefault>
              </Grid>
              <Divider
                sx={{
                  borderTop: "1px solid #F3F4F6",
                  width: "100%",
                  marginTop: "10px",
                }}
              />

              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Contact Number
                </StyledSecondaryTypography>
                <TypographyDefault>
                  +{accountDetails?.billing_detail?.country_code}{" "}
                  {accountDetails?.billing_detail?.phone}
                </TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Billing Cycle
                </StyledSecondaryTypography>
                <TypographyDefault>
                  {accountDetails?.billing_detail?.billing_cycle?.name}
                </TypographyDefault>
              </Grid>
            </Grid>
          </Box>

          <Box
            component="div"
            boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
            borderRadius="8px 8px 0px 0px"
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              px="16px"
              sx={{
                height: "66px",
                backgroundColor: "#FCFCFD",
                border: "1px solid #E5E7EB",
              }}
            >
              <Stack direction="row" alignItems="center" gap="10px">
                <SecondaryTypography>Project Information</SecondaryTypography>
              </Stack>
            </Stack>
            <Grid
              container
              xs={12}
              gap="2.8%"
              sx={{
                backgroundColor: "white",
                padding: "30px 16px 30px 16px",
                border: "1px solid #E5E7EB",
              }}
            >
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Project Title
                </StyledSecondaryTypography>
                <TypographyDefault>{accountDetails?.title}</TypographyDefault>
              </Grid>
              <Divider
                sx={{
                  borderTop: "1px solid #F3F4F6",
                  width: "100%",
                  marginTop: "10px",
                }}
              />
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>Type</StyledSecondaryTypography>
                <TypographyDefault>
                  {accountDetails?.type?.name}
                </TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  No. of Units
                </StyledSecondaryTypography>
                <TypographyDefault>
                  {accountDetails?.total_units}
                </TypographyDefault>
              </Grid>
              <Divider
                sx={{
                  borderTop: "1px solid #F3F4F6",
                  width: "100%",
                  marginTop: "10px",
                }}
              />
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>Address</StyledSecondaryTypography>
                <TypographyDefault>{accountDetails?.address}</TypographyDefault>
              </Grid>

              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>Tenure</StyledSecondaryTypography>
                <TypographyDefault>
                  {accountDetails?.tenure_year}
                </TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Completion Year
                </StyledSecondaryTypography>
                <TypographyDefault>
                  {accountDetails?.completion_year}
                </TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>Country</StyledSecondaryTypography>
                <TypographyDefault>{accountDetails?.country}</TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>City</StyledSecondaryTypography>
                <TypographyDefault>{accountDetails?.city}</TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Postal Code
                </StyledSecondaryTypography>
                <TypographyDefault>{accountDetails?.zipcode}</TypographyDefault>
              </Grid>
            </Grid>
          </Box>
          <Box
            component="div"
            boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
            borderRadius="8px 8px 0px 0px"
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              px="16px"
              sx={{
                height: "66px",
                backgroundColor: "#FCFCFD",
                border: "1px solid #E5E7EB",
              }}
            >
              <Stack direction="row" alignItems="center" gap="10px">
                <SecondaryTypography>Contact Details</SecondaryTypography>
              </Stack>
            </Stack>
            <Grid
              container
              xs={12}
              gap="2.8%"
              sx={{
                backgroundColor: "white",
                padding: "30px 16px 30px 16px",
                border: "1px solid #E5E7EB",
              }}
            >
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>Full Name</StyledSecondaryTypography>
                <TypographyDefault>
                  {accountDetails?.contact_detail?.name}
                </TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>Position</StyledSecondaryTypography>
                <TypographyDefault>
                  {accountDetails?.contact_detail?.position}
                </TypographyDefault>
              </Grid>
              <Divider
                sx={{
                  borderTop: "1px solid #F3F4F6",
                  width: "100%",
                  marginTop: "10px",
                }}
              />
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Email Address
                </StyledSecondaryTypography>
                <TypographyDefault>
                  {" "}
                  {accountDetails?.contact_detail?.email}
                </TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Contact Number
                </StyledSecondaryTypography>
                <TypographyDefault>
                  +{accountDetails?.contact_detail?.country_code}{" "}
                  {accountDetails?.contact_detail?.phone}
                </TypographyDefault>
              </Grid>
            </Grid>
          </Box>
          <Box
            component="div"
            boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
            borderRadius="8px 8px 0px 0px"
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              px="16px"
              sx={{
                height: "66px",
                backgroundColor: "#FCFCFD",
                border: "1px solid #E5E7EB",
              }}
            >
              <Stack direction="row" alignItems="center" gap="10px">
                <SecondaryTypography>Administrator Details</SecondaryTypography>
              </Stack>
            </Stack>
            <Grid
              container
              xs={12}
              gap="2.8%"
              sx={{
                backgroundColor: "white",
                padding: "30px 16px 30px 16px",
                border: "1px solid #E5E7EB",
              }}
            >
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>Full Name</StyledSecondaryTypography>
                <TypographyDefault>{accountDetails?.name}</TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Email Address
                </StyledSecondaryTypography>
                <TypographyDefault>{accountDetails?.email}</TypographyDefault>
              </Grid>
            </Grid>
          </Box>
          <Box
            component="div"
            boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
            borderRadius="8px"
          >
            <Stack
              direction="row"
              alignItems="center"
              px="16px"
              sx={{
                height: "66px",
                backgroundColor: "#FCFCFD",
                border: "1px solid #E5E7EB",
              }}
            >
              <SecondaryTypography>Onboarded by</SecondaryTypography>
            </Stack>
            <Grid
              container
              xs={12}
              gap="2.8%"
              sx={{
                backgroundColor: "white",
                padding: "30px 16px 30px 16px",
                border: "1px solid #E5E7EB",
                borderRadius: "0px 0px 8px 8px",
              }}
            >
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>
                  Client Lead
                </StyledSecondaryTypography>
                <TypographyDefault>
                  {accountDetails?.on_boarded_by?.name}
                </TypographyDefault>
              </Grid>
              <Grid xs={12} sm={5.8} sx={reviewstyle}>
                <StyledSecondaryTypography>Email</StyledSecondaryTypography>
                <TypographyDefault>
                  {accountDetails?.on_boarded_by?.email}
                </TypographyDefault>
              </Grid>
            </Grid>
          </Box>
        </>
      ) : PDF?.fileName ? (
        <Box sx={{ backgroundColor: "white", padding: "30px 16px 30px 16px" }}>
          <SecondaryTypography>Contract</SecondaryTypography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              border: "1px solid #EAECF0",
              borderRadius: "12px",
              p: 2,
              mt: 2,
              background: "#FFFFFF",
            }}
          >
            <Stack direction="row">
              <PDFIcon style={{ marginRight: "12px" }} />
              <Stack direction="column">
                <StyledSecondaryTypography>
                  {PDF?.fileName}.{PDF?.fileType}
                </StyledSecondaryTypography>
                <StyledSecondaryTypography>
                  {}
                  {PDF?.fileSize > 0
                    ? `${Math.max(PDF?.fileSize / 1024 / 1024, 0.01).toFixed(
                        2
                      )} MB`
                    : "0.00 MB"}
                </StyledSecondaryTypography>
              </Stack>
            </Stack>
            <Button variant="outlined" onClick={handleOpenPdf}>
              View
            </Button>
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            backgroundColor: "white",
            padding: "30px 16px",
            textAlign: "center",
            borderRadius: "12px",
            border: "1px solid #EAECF0",
          }}
        >
          <ExclamatoryIcon />
          <Typography
            sx={{
              color: "#9DA4AE",
              fontSize: "16px",
              fontWeight: 600,
              my: 2,
            }}
          >
            No contract uploaded yet.
          </Typography>
        </Box>
      )}
    </>
  );
};

export default ReviewAccount;
